import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import OnGoingBidsSection from '../components/OnGoingBids'
import ScrollToTop from '../components/ScrollToTop'

function OnGoingBidsPage() {

    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />

            <Navbar toggle={toggle} />

            <OnGoingBidsSection />

            <Footer />
        </div>
    )
}

export default OnGoingBidsPage